// extracted by mini-css-extract-plugin
module.exports = {"custom-item":"src-containers-Calendar-components-BlankItem-styles__custom-item--3ek-N","item-title":"src-containers-Calendar-components-BlankItem-styles__item-title--VfubG"};